import classNames from 'classnames'
import { motion } from 'framer-motion'
import { PropsWithChildren } from 'react'

import { commonIcons } from '@apps-common/config/icons'
import { useNavigation } from '@apps-common/hooks/useNavigation'
import { useWindowDimensions } from '@apps-common/hooks/useWindowDimensions'
import { useMenuStore } from '@apps-common/stores/menuStore'
import { ROUTE_DASHBOARD } from '@apps-radionet-portal/config/private-routes'

interface ItemProps {
  showBack?: boolean
  transparent?: boolean
  icons?: any
  startComponents?: any
}

export const Navbar = ({ showBack, transparent, icons, startComponents }: PropsWithChildren<ItemProps>) => {
  const { width, isMobile, isTablet } = useWindowDimensions()
  const { navigateBack } = useNavigation()
  const { open, setOpen } = useMenuStore()
  const MenuIcon = commonIcons.menu
  const BackIcon = commonIcons.back

  const shadow = transparent ? '' : 'shadow-sm'
  const bgColor = transparent ? '' : 'bg-accent'
  const textColor = transparent ? 'text-content' : 'text-accent-content'

  return (
    <motion.div
      animate={{
        opacity: open ? 0.5 : 1,
        transition: { type: 'tween' }
      }}
      className={classNames('text-text w-full')}
      onClick={() => {
        if (open) {
          setOpen(false)
        }
      }}
    >
      <div className={classNames('flex h-[40px] md:h-[55px] justify-center transition-all duration-100', bgColor, shadow)}>
        <div className={classNames('w-full flex items-center justify-between', bgColor)}>
          <div className='flex items-center justify-start gap-[10px] md:flex-none lg:gap-0'>
            <label htmlFor='my-drawer' className='drawer-button flex items-center justify-start gap-[5px]'>
              {(isMobile || isTablet) && (
                <button
                  type='button'
                  aria-label='Back'
                  className='w-[36px] h-[36px] sm:w-[40px] sm:h-[40px] rounded-full bg-surface text-text border border-border flex items-center justify-center hover:opacity-70'
                  onClick={() => setOpen(true)}
                >
                  <MenuIcon className={classNames('text-[1.3rem]', textColor)} />
                </button>
              )}
              {showBack && (
                <button
                  type='button'
                  aria-label='Back'
                  className='w-[36px] h-[36px] sm:w-[40px] sm:h-[40px] rounded-full bg-surface text-text border border-border flex items-center justify-center hover:opacity-70'
                  onClick={() => navigateBack({ routeUrl: ROUTE_DASHBOARD.buildPath(), route: ROUTE_DASHBOARD })}
                >
                  <BackIcon className={classNames('text-[1.3rem]', textColor)} />
                </button>
              )}
            </label>
            <div>{startComponents}</div>
          </div>
          <div className='pr-0'>{icons}</div>
        </div>
      </div>
    </motion.div>
  )
}
